import axios from "axios";
import GeneralBloc from "../bloc/general_bloc";
import LanguageBloc from "../bloc/language_bloc";
import SessionBloc from "../bloc/session_bloc";
import Config from "../Config";
import BaseResponseJson from "../data/web/base_response_json";
import AuthBloc from "../bloc/auth_bloc";
import RouteBloc from "../bloc/route_bloc";
import ListingResponseJson from "../data/web/listing_response_json";

class BaseWebService {
  static baseUrl() {    
    return process.env.REACT_APP_BASE_URL + this.getContextPathBySource();
  }

  static version() {
    return process.env.REACT_APP_RELEASE_VERSION;
  }

  static headersFromSession(session) {
    let lang = LanguageBloc.getSelectedLanguageForAPI();

    return {
      ChannelId: Config.channel,
      Language: lang,
      Authorization: SessionBloc.generateStatelessAuth(),
      PartnerCode: (session.partnerCode || "").toUpperCase(),
      Product: (session.productCode || "").toUpperCase(),
      CorrelationId: session.trxId,
      "Content-Type": "application/json",
      Version: BaseWebService.version(),
      Accept: "*/*",
    };
  }

  static async fixedHeaders(){
    let token = await AuthBloc.currentAccessToken();    

    let headers={
      "Authorization": "Bearer " + token,              
    }

    return headers;
  }

  static async headers() {
    let token=null;
    const session = await AuthBloc.checkSession();    
    if (session) {
      token = session.accessToken;
    }

    let headers={
      "Authorization": "Bearer " + token,              
    }

    return headers;
  }

  static async standardHeaders() {
    let token=null;
    const session = await AuthBloc.checkSession();    
    if (session) {
      token = session.accessToken;
    }

    let selectedBank=RouteBloc.getSelectedBank()
    let headers={};
    if(selectedBank){
      headers= {
        "Authorization": "Bearer " + token,
        "entity":selectedBank.id
      };
    } else {
      headers= {
        "Authorization": "Bearer " + token,
      };
    }    
    return headers;
  }

  static async normalHeaders() {
    let token = null;
    const session = await AuthBloc.checkSession();
    if (session) {
      token = session.accessToken;
    }
    // token = 'SHA002-JUST-let-me-in';
    let headers = {};

    headers = {
      'Content-Type': 'application/json',
      // "Access-Control-Allow-Origin": "*",
      "Authorization": "Bearer " + token,
    };
    return headers;
  }

  static noTokenHeaders() {
    return {
      "Content-Type": "application/json",
    };
  }

  static async clientStandardHeaders() {
    let token = null;
    const session = await JSON.parse(localStorage.getItem("dataClient"));
    if (session) {
      token = session.accessToken;
    }
    let headers = {};

    headers = {
      'Content-Type': 'application/json',
      "Authorization": "Bearer " + token,
    };
    return headers;
  }

  static emptyHeader() {
    let lang = GeneralBloc.getSelectedLanguage();
    let newLang = lang === "eng" ? "EN" : "BN";
    return {
      /* 'ChannelId': "fwdbanca", */
      Language: newLang,
      Authorization: SessionBloc.generateStatelessAuth(),
      "Content-Type": "application/json",
      Version: BaseWebService.version(),
      Accept: "*/*",
    };
  }

  static getContextPathBySource() {    
    return "/v1";
  }

  static baseResponseFromWeb(resp) {
    let success = resp.errcode == null || resp.errcode === "";
    let message = resp.errmsg;
    let code = resp.errcode;
    let errorCode = resp.errcode;
    let data = resp.result;

    return new BaseResponseJson(success, message, code, data, errorCode);
  }


  static standardResponseFromWeb(resp) {
    let success = resp.success;
    let message = resp.message;
    let code = resp.status;
    let errorCode = resp.errors;
    let data = resp.data;
    return new BaseResponseJson(success, message, code, data, errorCode);
  }

  static listingQuotationResponseFromWeb(resp) {
    let success = resp.success;
    let message = resp.message;
    let code = resp.status;
    let errorCode = resp.errors;
    let data = resp.data;
    let page = resp.page;
    let sort = resp.sort;
    return new ListingResponseJson(success, message, code, data, errorCode, page, sort);
  }
}

export default BaseWebService;
